<template>
  <div class="assistant-card">
    <p class="shipping-card__title">Envío · elige un servicio</p>
    <label
      v-for="option in options"
      :key="option.serviceCode"
      class="shipping-option"
      :class="{ 'is-selected': selectedCode === option.serviceCode }"
    >
      <input
        type="radio"
        :name="cardId"
        :checked="selectedCode === option.serviceCode"
        @change="choose(option)"
      />
      <span class="shipping-option__name">{{ option.service }}</span>
      <span class="shipping-option__price">{{ money(option.price) }}</span>
    </label>
  </div>
</template>

<script>
import { money } from "../format.js";

// Opciones de quote_shipping. Elegir una le pide a Claude que la ponga en la
// cotización (AssistantBubble)
export default {
  name: "ShippingOptionsCard",
  props: {
    cardId: { type: String, required: true },
    options: { type: Array, required: true }
  },
  data() {
    return { selectedCode: null };
  },
  methods: {
    money,
    choose(option) {
      this.selectedCode = option.serviceCode;
      this.$emit("select", option);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./card.scss";

.shipping-card__title {
  margin-bottom: 6px;
  font-weight: 600;
}
.shipping-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px;
  border: 1px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  &:hover {
    background: #f9fafb;
  }
  &.is-selected {
    border-color: #2563eb;
    background: #eff6ff;
  }
}
.shipping-option__name {
  flex: 1;
  min-width: 0;
}
.shipping-option__price {
  white-space: nowrap;
  font-weight: 600;
}
</style>
